import React from 'react';
import { Anchor } from '@atlassiansox/bxp-content-framework';
import { useAnalytics } from './';
export function MarkdownLink({ href, title, children }) {
    var _a;
    const { sendTrackEvent } = useAnalytics();
    return (React.createElement(Anchor, { href: href, title: title, onClick: () => {
            var _a, _b;
            sendTrackEvent('clickedAnchor', {
                event: 'clicked',
                eventComponent: 'link',
                eventContainer: 'uiMarkdown',
                label: (_a = children[0]) === null || _a === void 0 ? void 0 : _a.props.value,
                uuid: (_b = children[0]) === null || _b === void 0 ? void 0 : _b.props.nodeKey,
                href: href,
                title: title
            });
        }, "data-uuid": (_a = children[0]) === null || _a === void 0 ? void 0 : _a.props.nodeKey },
        React.createElement(React.Fragment, null, children)));
}
//# sourceMappingURL=MarkdownLink.js.map